import React from 'react';

export default function Glossary({ onHome, onPreview, onRunFullBattery }) {
  return (
    <div style={{ maxWidth: '800px', margin: '3rem auto', padding: '2rem', lineHeight: 1.6 }}>

      {/* Button Block - Top Left */}
      <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
        <button
          onClick={onHome}
          style={{
            display: 'block',
            marginBottom: '0.5rem',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
       
          🏠 Home
        </button>

        <button
          onClick={onRunFullBattery}
          style={{
            display: 'block',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          🚀 Run Full Battery
        </button>
      </div>

      {/* Glossary Content */}
      <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>Glossary</h1>

      <p><strong>Executive Function</strong>: A set of mental skills including working memory, cognitive flexibility, and inhibitory control used for planning and decision-making.</p>
      <p><strong>Working Memory</strong>: The system responsible for temporarily holding and manipulating information necessary for complex tasks such as reasoning and learning.</p>
      <p><strong>Cognitive Flexibility</strong>: The capacity to adapt thinking and behavior in response to changing goals or environmental stimuli.</p>
      <p><strong>Inhibitory Control</strong>: The ability to suppress automatic, impulsive, or habitual responses to achieve goal-directed behavior.</p>
      <p><strong>Response Inhibition</strong>: The capacity to withhold or stop actions that are inappropriate or no longer required.</p>
      <p><strong>Interference Control</strong>: The ability to ignore irrelevant information or suppress competing thoughts while completing a task.</p>
      <p><strong>Attention</strong>: The cognitive process of selectively focusing on specific information while ignoring distractions.</p>
      <p><strong>Processing Speed</strong>: The rate at which individuals can perceive, process, and respond to information.</p>
      <p><strong>Set-Shifting</strong>: The ability to shift attention between different tasks or mental frameworks.</p>
      <p><strong>Mood</strong>: Emotional states such as sadness, irritability, or anhedonia that can impact cognitive performance and daily functioning.</p>

    </div>
  );
}
